'use client';

import { BodyText, H2 } from '@/lib/StyledComponents/Typography';
import type { LinkButtonBlockData } from '@/schema/cms/blocks/LinkButtonBlock';
import styled from 'styled-components';
import { LinkButton } from './CmsBlocks/LinkButton';
import { Section } from './SectionWrapper';
import { mq } from '@/lib/StyledComponents/mq';

const CTAContainer = styled.div`
  padding: 3.5rem 2rem;
  text-align: center;
`;

const StyledH2 = styled(H2)`
  margin-bottom: 0.625rem;
`;

const StyledLinkButton = styled(LinkButton)`
  display: inline-block;
  margin-top: 1.25rem;
  width: 100%;

  ${mq('mobileL')} {
    width: auto;
  }
`;

type CTAProps = {
  title: string | null;
  description: string | null;
  btnProps: LinkButtonBlockData;
};

export const CTASection = ({ title, description, btnProps }: CTAProps) => {
  return (
    <Section>
      <CTAContainer>
        {title && <StyledH2>{title}</StyledH2>}
        {description && <BodyText>{description}</BodyText>}
        {btnProps && (
          <StyledLinkButton
            href={btnProps?.url}
            $textColor={btnProps.textColorNew}
            $backgroundColor={btnProps.backgroundColorNew}
            $variant={btnProps.variant}
          >
            {btnProps?.label}
          </StyledLinkButton>
        )}
      </CTAContainer>
    </Section>
  );
};
